import * as microsoftTeams from '@microsoft/teams-js';
import { TEAMS_APP_ID } from '../constants';

/**
 * Opens a recording in a new Teams window using stageView API.
 * Falls back to modal if popout is not supported (e.g., in web client).
 */
export const openRecordingInTeamsWindow = async (recordingId: string): Promise<void> => {
  const contentUrl = `${window.location.origin}/recording/${recordingId}`;

  if (microsoftTeams.stageView.isSupported()) {
    try {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      await microsoftTeams.stageView.open({
        appId: TEAMS_APP_ID!,
        contentUrl,
        title: 'Réunion',
        openMode: microsoftTeams.stageView.StageViewOpenMode.popout,
      });
    } catch (error) {
      console.error('Failed to open stageView:', error);
      // Fallback to browser window if stageView fails
      window.open(contentUrl, '_blank', 'noopener,noreferrer');
    }
  } else {
    // Fallback for unsupported environments
    window.open(contentUrl, '_blank', 'noopener,noreferrer');
  }
};
